export const APP_VERSION = process.env.APP_VERSION || '2.0.8';

export const STRICT_LANGUAGES = [
  // Destaques
  { code: 'en', name: 'Inglês' },
  { code: 'fr', name: 'Francês' },
  { code: 'it', name: 'Italiano' },
  { code: 'es', name: 'Espanhol' },
  { code: 'de', name: 'Alemão' },
  { code: 'pt', name: 'Português' },
  { code: 'ja', name: 'Japonês' },
  // Restante
  { code: 'af', name: 'Africâner' },
  { code: 'ar', name: 'Árabe' },
  { code: 'arp', name: 'Arp' },
  { code: 'bo', name: 'Bo' },
  { code: 'br', name: 'Bretão' },
  { code: 'bg', name: 'Búlgaro' },
  { code: 'ca', name: 'Catalão' },
  { code: 'ceb', name: 'Cebuano' },
  { code: 'zh', name: 'Chinês' },
  { code: 'da', name: 'Dinamarquês' },
  { code: 'enm', name: 'Enm' },
  { code: 'sl', name: 'Esloveno' },
  { code: 'eo', name: 'Esperanto' },
  { code: 'et', name: 'Estoniano' },
  { code: 'tl', name: 'Filipino' },
  { code: 'fi', name: 'Finlandês' },
  { code: 'fy', name: 'Frísio ocidental' },
  { code: 'fur', name: 'Fur' },
  { code: 'gd', name: 'Gaélico escocês' },
  { code: 'gl', name: 'Galego' },
  { code: 'cy', name: 'Galês' },
  { code: 'el', name: 'Grego' },
  { code: 'he', name: 'Hebraico' },
  { code: 'nl', name: 'Holandês' },
  { code: 'hu', name: 'Húngaro' },
  { code: 'ilo', name: 'Ilocano' },
  { code: 'ia', name: 'Interlíngua' },
  { code: 'ga', name: 'Irlandês' },
  { code: 'is', name: 'Islandês' },
  { code: 'iu', name: 'Iu' },
  { code: 'la', name: 'Latim' },
  { code: 'mi', name: 'Maori' },
  { code: 'myn', name: 'Myn' },
  { code: 'nah', name: 'Nah' },
  { code: 'nap', name: 'Nap' },
  { code: 'no', name: 'Norueguês' },
  { code: 'oc', name: 'Occitânico' },
  { code: 'oj', name: 'Oji' },
  { code: 'fa', name: 'Persa' },
  { code: 'pl', name: 'Polonês' },
  { code: 'rmq', name: 'Rmq' },
  { code: 'ro', name: 'Romeno' },
  { code: 'ru', name: 'Russo' },
  { code: 'sa', name: 'Sânscrito' },
  { code: 'sco', name: 'Sco' },
  { code: 'sr', name: 'Sérvio' },
  { code: 'sv', name: 'Sueco' },
  { code: 'cs', name: 'Tcheco' },
  { code: 'te', name: 'Télugo' }
];

// Cores de destaque da marca LibriTui (a primeira é o padrão: Laranja Tui)
export const BRAND_ACCENTS = ['#E8823F', '#B08D57', '#7F8A55', '#B5525E', '#5E7FA3'];
export const brandAccent = (hex?: string | null): string =>
  BRAND_ACCENTS.find(c => c.toLowerCase() === String(hex || '').toLowerCase()) || BRAND_ACCENTS[0];
